import { render, staticRenderFns } from "./SkillTabs.vue?vue&type=template&id=6a20f30e&"
import script from "./SkillTabs.vue?vue&type=script&lang=js&"
export * from "./SkillTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports